module.exports = __webpack_public_path__ + "img/tz.1a630428.svg";